import React from 'react';
import NavbarComponent from '../pages/Navbar'; // ✅ fixed path
import Footer from '../Footer';
import GalleryBanner from './GalleryBanner';
import GallerySection from './GallerySection';


const Gallery = () => {
  return (
    <>
      <NavbarComponent />
<GalleryBanner/>
      <GallerySection/>

      <Footer />
    </>
  );
};

export default Gallery;
